import {
    Component,
    Input, OnDestroy,
    OnInit
} from '@angular/core';
import {EntityService} from "@signature-it/ngx-entity/services";
import {Store} from '@ngrx/store';
declare let _ : any;
import * as EntityActions from '@signature-it/ngx-entity/store/actions';
import * as EntitySelectors from '@signature-it/ngx-entity/store/selectors';
import {takeUntil,filter,take} from "rxjs/operators";
import {Observable, Subscription, Subject} from "rxjs";


@Component({
    selector: 'item-preview',
    templateUrl: './item-preview.component.html',
    styleUrls: ['./item-preview.component.scss'],
    standalone: false
})
export class ItemPreviewComponent  implements OnInit,OnDestroy{
    @Input() api: string;
    @Input() previewTemplateVar: string ;
    @Input() item: any;
    templates$: Observable<string>;
    templatesPreview: Array<any> = [];
    items: Array<any> = [] ;
    html: string;
    scripts: string;
    private destroy$: Subject<void> = new Subject<void>();
    constructor(protected entiyService: EntityService, protected store$: Store<any>) {
        this.templates$ = this.store$.select(EntitySelectors.getPreviews);
    }
    ngOnInit() {
        if(this.previewTemplateVar){
            this.store$.dispatch(EntityActions.getPreviews());
            this.templates$.pipe(takeUntil(this.destroy$),
                filter(templates => templates && templates[this.previewTemplateVar]),
                take(1)).subscribe(templates=>{
                    this.HTMLtags(templates[this.previewTemplateVar]);
                    if (this.api) {
                        this.entiyService.callApi(this.api).subscribe(
                            response => {
                                let items = response?.['response']?.['docs'] || response;
                                this.items =  items.data ? Object.values(items.data) : items;
                            }
                        )
                    }
                    else{
                        this.items.push(this.item);
                    }
            })
        }
    }
    HTMLtags(str){
        const scriptsReg = /<script\b[^>]*>[\s\S]*?<\/script\b[^>]*>/g;
        this.scripts = str.match(scriptsReg)?.join('');
        this.html = str;
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

}
